import { requestSeoLinks } from '../../api/seo_links';
import { IThunkActionCreator } from '../index';

export interface ISeoLink {
  uri: string;
  name: string;
}

export interface ISeoBlock {
  links: ISeoLink[];
  title: string;
}

export interface ISeoLinks {
  seoBlocks: ISeoBlock[];
}

export interface ISeoLinksState {
  seoLinks: ISeoLinks;
  isLoad: boolean;
}

export interface ISeoLinkRequest {
  type: 'ISeoLinkRequest';
}

export interface ISeoLinkResponseSuccess {
  type: 'ISeoLinkResponseSuccess';
  payload: {
    seoBlocks: ISeoBlock[];
  };
}

export interface ISeoLinkResponseError {
  type: 'ISeoLinkResponseError';
}

export function getSeoLinks(offerId: number): IThunkActionCreator {
  return (dispatch, getState, context) => {
    dispatch({
      type: 'ISeoLinkRequest',
    });

    const seoCrossLinksApiBaseUrl = context.config.get('seoCrossLinksApiBaseUrl') as string || '';

    if (!seoCrossLinksApiBaseUrl) {
      dispatch({ type: 'ISeoLinkResponseError' });
    }

    requestSeoLinks(context.makeRequest, seoCrossLinksApiBaseUrl, offerId)
      .then((response: ISeoLinks) => {
        dispatch({
          payload: {
            seoBlocks: response.seoBlocks,
          },
          type: 'ISeoLinkResponseSuccess',
        });
      })
      .catch(() => dispatch({ type: 'ISeoLinkResponseError' }));
  };
}

export type TSeoLinksACtions =
  ISeoLinkRequest |
  ISeoLinkResponseSuccess |
  ISeoLinkResponseError;

const initialState: ISeoLinksState = {
  isLoad: false,
  seoLinks: {
    seoBlocks: [],
  },
};

export function seoLinksReducer(
  state: ISeoLinksState = initialState,
  action: TSeoLinksACtions,
) {
  switch (action.type) {
    case 'ISeoLinkRequest':
      return {
        ...state,
        isLoad: true,
      };

    case 'ISeoLinkResponseError':
      return {
        ...state,
        isLoad: false,
      };

    case 'ISeoLinkResponseSuccess':
      return {
        ...state,
        isLoad: false,
        seoLinks: {
          seoBlocks: action.payload.seoBlocks,
        },
      };

    default:
      return state;
  }
}
